import { ACTION_NAVIGATION_TOGGLE, ACTION_MOBILE_NAVIGATION_TOGGLE } from './navigation-actions'
import { AnyAction } from 'redux'
import { makeReducer } from 'utils'
import { ActionReducer, Reducers } from 'shared-components/src/utils/make-reducer'

export type NavigationState = {
    menuExpanded: boolean
    mobileMenuExpanded: boolean
}

type NavigationReducer = ActionReducer<NavigationState, AnyAction>

const initialState: NavigationState = {
    menuExpanded: false,
    mobileMenuExpanded: false,
}

const toggleNavigation: NavigationReducer = (state, action) => ({
    ...state,
    menuExpanded: action.expanded,
})
const toggleMobileNavigation: NavigationReducer = (state, action) => ({
    ...state,
    mobileMenuExpanded: action.expanded,
})

const reducers: Reducers<NavigationState> = {
    [ACTION_NAVIGATION_TOGGLE]: toggleNavigation,
    [ACTION_MOBILE_NAVIGATION_TOGGLE]: toggleMobileNavigation,
}

export const navigationReducer = makeReducer(reducers, initialState)
